export const iconFontAwesomeTravelHotelCarTunnel = (
	<i className="fa-solid fa-car-tunnel"></i>
);
